<template>
    <CodiceFeanorView tool-module="stegoExtract" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
